import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';

export default function usePortraitInteraction(root, enabled) {
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const media = gsap.matchMedia();
    media.add('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)', (context) => {
      const avatar = root.current.querySelector('.hero__avatar');
      const portrait = root.current.querySelector('.hero__portrait-motion');
      const orbit = root.current.querySelector('.hero__portrait-orbit');
      const stars = root.current.querySelectorAll('.hero__portrait-star');
      const x = gsap.quickTo(portrait, 'x', { duration: .65, ease: 'power3' });
      const y = gsap.quickTo(portrait, 'y', { duration: .65, ease: 'power3' });
      const rotateX = gsap.quickTo(portrait, 'rotationX', { duration: .65, ease: 'power3' });
      const rotateY = gsap.quickTo(portrait, 'rotationY', { duration: .65, ease: 'power3' });
      const move = (event) => {
        if (event.pointerType !== 'mouse') return;
        const box = avatar.getBoundingClientRect();
        const nx = (event.clientX - box.left) / box.width - .5;
        const ny = (event.clientY - box.top) / box.height - .5;
        x(nx * 10); y(0); rotateX(0); rotateY(nx * 8);
      };
      context.add('enter', (event) => {
        if (event.pointerType !== 'mouse') return;
        gsap.to(portrait, { scale: 1.018, duration: .65, ease: 'power3.out', overwrite: 'auto' });
        gsap.to(orbit, { scale: 1.1, rotation: 12, opacity: .85, duration: .8, overwrite: 'auto' });
        gsap.to(stars, { rotation: 80, scale: 1.3, duration: .8, stagger: .08, ease: 'back.out(1.5)', overwrite: 'auto' });
      });
      context.add('leave', () => {
        x(0); y(0); rotateX(0); rotateY(0);
        gsap.to(portrait, { scale: 1, duration: .7, overwrite: 'auto' });
        gsap.to(orbit, { scale: 1, rotation: 0, opacity: .3, duration: .8, overwrite: 'auto' });
        gsap.to(stars, { rotation: 0, scale: 1, duration: .7, overwrite: 'auto' });
      });
      avatar.addEventListener('pointermove', move); avatar.addEventListener('pointerenter', context.enter); avatar.addEventListener('pointerleave', context.leave);
      return () => { avatar.removeEventListener('pointermove', move); avatar.removeEventListener('pointerenter', context.enter); avatar.removeEventListener('pointerleave', context.leave); };
    });
    return () => media.revert();
  }, [root, enabled]);
}
